// libraries.
import { Outlet } from "react-router-dom";

// components.
import { SidebarSupport } from "./components/SidebarSupport/SidebarSupport";

export const SupportPage = () => {
  return (
    <div className="d-flex overflow-hidden h-100">
      <div>
        <SidebarSupport />
      </div>
      <div
        className="d-flex flex-column w-100 h-100"
        data-testid="support-page"
      >
        <Outlet />
      </div>
    </div>
  );
};
